import sharedTranslations from './shared.json';

export default {
  ...sharedTranslations,
  "aboutArtists.form.applyStart": "Apply for my first show",
  "aboutHosts.form.applyStart": "Apply to host a Sofar",
  "blogPreviewCard.defaultLinkCTA": "Continue Reading",
  "cities.upcomingAllCities": "Upcoming events from all cities",
  "competition.optInModal.title": "Allow Data Sharing",
  "competition.optInModal.dataSharingNotRequired": "Data sharing is not required to enter competition.",
  "competition.optInModal.footerText": "By making a selection above, you will be entered to win two tickets to this event.",
  "competition.authentication.byClickingYouWillBeEntered": "By clicking \"{authType}\" you will be entered to win two tickets to this event.",
  "eventGrid.emptyState.noEventsMatchFilters": "No events in {city} match your filters. Remove some filters to broaden your search.",
  "eventGrid.emptyState.noEventsHappening": "No events happening in {city}",
  "eventGrid.metaInfoBar.text": "Upcoming Sofar Events in {city}",
  "eventGrid.filterSelected": "FILTER SELECTED",
  "eventGrid.filtersSelected": "FILTERS SELECTED",
  "eventGrid.filter.ticketsAvailable": "Tickets Available",
  "eventGrid.filter.next7Days": "Next 7 Days",
  "eventGrid.filter.next30Days": "Next 30 Days",
  "eventGrid.filter.indoor": "Indoor",
  "eventGrid.filter.outdoor": "Outdoor",
  "eventGrid.filter.byob": "BYOB",
  "eventGrid.newsletter.canNotFindShow": "Can’t find a show?",
  "eventGrid.newsletter.collapsableLeadGen": "SAVE ON YOUR FIRST SHOW",
  "eventGrid.newsletter.firstTimeHere": "Sign up and get 10% off",
  "eventGrid.newsletter.signUp": "Sign up to our newsletter to be the first to hear about relevant upcoming Sofar shows in your area.",
  "eventGrid.newsletter.signUpWithPromoCode": "Sign up for our weekly newsletter to hear about shows in your area and get 10% off tickets to your next show!",
  "eventGrid.newsletter.submit": "Submit",
  "eventGrid.newsletter.success": "Success",
  "eventGrid.newsletter.successMessage": "You have successfully signed up for our Newsletter!",
  "eventGrid.newsletter.successMessageLeadGenOffer": "Check your inbox for your email and 10% off promo code.",
  "eventGrid.newsletter.successTitleLeadGenOffer": "Thanks for signing up!",
  "metaInfoBar.allSoldOutState.title": "Sold out",
  "metaInfoBar.allSoldOutState.body": "Sorry, all upcoming events in this city are temporarily sold out.",
  "metaInfoBar.allSoldOutState.cta": "Need a music fix now? Check out our <a>Listening Room</a> for exclusive content from artists around the world.",
  "loadAllEvents": "Load All Events",
  "loadMore": "Load More",
  "byob": "BYOB",
  "petPresent": "Pet Present",
  "accessible": "Accessible",
  "outdoor": "Outdoor",
  "secretLocation": "Secret Location",
  "past": "Past Event",
  "paused": "Tickets Currently Unavailable",
  "cancelled": "Event Cancelled",
  "soldOut": "Sold Out",
  "competitionClosed": "Competition Closed",
  "youEntered": "You have entered",
  "youApplied": "You have applied",
  "youreNoLongerAttending": "You are no longer attending",
  "youWon": "You have won",
  "youreInvited": "You have been invited",
  "youHaveXTickets": "YOU HAVE {tickets} TICKET{s}"
}
